package com.mgacreative.hotelru.feature.hotel.ui.auth

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mgacreative.hotelru.shared.ui.designsystem.components.HFLoadingState
import com.mgacreative.hotelru.shared.ui.designsystem.components.HFTextField
import com.mgacreative.hotelru.shared.ui.designsystem.components.LanguageSelectorRow
import com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n
import com.mgacreative.hotelru.feature.hotel.ui.components.AppLogo

@Composable
fun ForgotPasswordScreen(viewModel: AuthViewModel) {
    var email by remember { mutableStateOf("") }
    
    val isLoading by viewModel.isLoading.collectAsState()
    val error by viewModel.errorMessage.collectAsState()

    if (isLoading) {
        HFLoadingState()
        return
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(
                Brush.verticalGradient(
                    colors = listOf(
                        MaterialTheme.colorScheme.primary.copy(alpha = 0.8f),
                        MaterialTheme.colorScheme.primaryContainer
                    )
                )
            ),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier.padding(24.dp).widthIn(max = 480.dp).fillMaxWidth()
        ) {
            LanguageSelectorRow(modifier = Modifier.padding(bottom = 16.dp))

            AppLogo(modifier = Modifier.size(100.dp).padding(bottom = 24.dp))
            
            Card(
                shape = RoundedCornerShape(24.dp),
                colors = CardDefaults.cardColors(
                    containerColor = MaterialTheme.colorScheme.surface.copy(alpha = 0.95f)
                ),
                elevation = CardDefaults.cardElevation(defaultElevation = 8.dp),
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier.padding(32.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        text = l10n("Şifre Sıfırlama"),
                        fontSize = 24.sp,
                        fontWeight = FontWeight.Bold,
                        color = MaterialTheme.colorScheme.onSurface
                    )
                    Spacer(Modifier.height(8.dp))
                    Text(
                        text = l10n("E-posta adresinize sıfırlama bağlantısı gönderilecektir"),
                        fontSize = 14.sp,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        textAlign = androidx.compose.ui.text.style.TextAlign.Center
                    )
                    Spacer(Modifier.height(32.dp))
                    
                    HFTextField(
                        value = email,
                        onValueChange = { email = it },
                        label = l10n("E-posta adresiniz"),
                        isError = error != null
                    )
                    
                    if (error != null) {
                        Spacer(Modifier.height(8.dp))
                        Text(
                            text = error!!, 
                            color = MaterialTheme.colorScheme.error,
                            fontSize = 12.sp,
                            modifier = Modifier.fillMaxWidth()
                        )
                    }

                    Spacer(Modifier.height(32.dp))
                    
                    Button(
                        onClick = { viewModel.resetPassword(email) },
                        modifier = Modifier.fillMaxWidth().height(56.dp),
                        shape = RoundedCornerShape(16.dp),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = MaterialTheme.colorScheme.primary
                        )
                    ) {
                        Text(l10n("Sıfırlama Bağlantısı Gönder"), fontSize = 16.sp, fontWeight = FontWeight.SemiBold)
                    }
                    
                    Spacer(Modifier.height(24.dp))
                    
                    TextButton(onClick = { viewModel.authNavigator.navigateTo(AuthScreenType.LOGIN) }) {
                        Text(l10n("Giriş Ekranına Dön"), color = MaterialTheme.colorScheme.primary)
                    }
                }
            }
        }
    }
}

